import { render, staticRenderFns } from "./VisualizarPraticasLinguagemDialog.vue?vue&type=template&id=53d6401a"
import script from "./VisualizarPraticasLinguagemDialog.vue?vue&type=script&lang=js"
export * from "./VisualizarPraticasLinguagemDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports